import React from "react";
import {
  InviteContainer,
  InviteLinkContainer,
  InviteCopyButton,
  InviteHeader,
  InviteLinkBox,
} from "./Invite.styled";
import { useSelector } from "react-redux";

const Invite = () => {
  const { user } = useSelector((state) => state.user);
  const APP_URL = process.env.REACT_APP_URL;
  const shareData = {
    title: "Referral Link",
    // text: "Referral link",
    url: `${APP_URL}/register?referral=${
      Object.keys(user).length && user.referral_code
    }`,
  };
  return (
    <InviteContainer>
      <InviteLinkContainer>
        <InviteHeader>My Invitation Link</InviteHeader>
        <InviteLinkBox>{shareData.url}</InviteLinkBox>
        <InviteCopyButton
          onClick={() => {
            if (navigator.share) {
              navigator
                .share(shareData)
                .then(() => {
                  console.log("Thanks for sharing!");
                })
                .catch(console.error);
            }
          }}
        >
          Copy and share link
        </InviteCopyButton>
        <h3>
          My invitation code: {Object.keys(user).length && user.referral_code}
        </h3>
      </InviteLinkContainer>
      <div style={{ border: "1px solid #7B36EE", paddingInline: "10px" }}>
        <h2>Invitation Rules</h2>
        <h3>Level 1 (Direct Referrals)</h3>
        <p>1. Earn 7% of your direct referrals' daily mining rewards</p>
        <p>
          2. Your direct referrals must purchase and own virtual mining machines
          to be eligible for referral rewards.
        </p>
        <p>
          3. Referral rewards are credited to your account automatically on a
          daily basis.
        </p>
        <p>
          4. There is no limit to the number of direct referrals you can have.
        </p>
        <h3>Level 2 (Indirect Referrals)</h3>
        <div>
          <p>1. Earn 5% of your indirect referrals' daily mining rewards</p>
          <p>
            2. Indirect referrals are users referred by your direct referrals.
          </p>
          <p>
            3. Referral rewards are credited to your account automatically on a
            daily basis.
          </p>
          <p>
            4. There is no limit to the number of indirect referrals you can
            have
          </p>
        </div>
        <h3>Level 3 (Network Referrals)</h3>
        <div>
          <p>1. Earn 2% of your network referrals' daily mining rewards.</p>
          <p>
            2. Network referrals are users referred by your indirect referrals.
          </p>
          <p>
            3. Referral rewards are credited to your account automatically on a
            daily basis.
          </p>
          <p>
            4. There is no limit to the number of network referrals you can
            have.
          </p>
        </div>

        <p>
          <span style={{ fontWeight: "bold" }}>Note:</span> Referral rewards are
          calculated based on the daily mining rewards earned by your referrals,
          and are subject to change at the discretion of Pubmining. It is
          important to review and adhere to the referral program terms and
          conditions as specified on the Pubmining platform.
        </p>
      </div>
    </InviteContainer>
  );
};

export default Invite;
